module.exports = __webpack_public_path__ + "img/copy.10ea2c32.svg";